export const DEFAULT_CURRENCY = 'USD';

const formatters = {};
const formatterFor = (code) => {
  if (!formatters[code]) {
    try {
      formatters[code] = new Intl.NumberFormat('en-US', { style: 'currency', currency: code, currencyDisplay: 'symbol' });
    } catch {
      formatters[code] = new Intl.NumberFormat('en-US', { style: 'currency', currency: DEFAULT_CURRENCY });
    }
  }
  return formatters[code];
};

export const formatMoney = (amount, code = DEFAULT_CURRENCY) => formatterFor(code || DEFAULT_CURRENCY).format(Number(amount) || 0);

export const currencySymbol = (code) =>
  formatterFor(code || DEFAULT_CURRENCY).formatToParts(0).find((p) => p.type === 'currency')?.value || code;

// Sum rows per currency; returns "$1,200.00 · €300.00" (or a single value).
export const formatTotals = (rows, amountOf, currencyOf) => {
  const sums = {};
  rows.forEach((r) => {
    const c = currencyOf(r);
    sums[c] = (sums[c] || 0) + (Number(amountOf(r)) || 0);
  });
  const codes = Object.keys(sums);
  if (!codes.length) return formatMoney(0, currencyOf({}));
  const nonZero = codes.filter((c) => sums[c] !== 0);
  const shown = nonZero.length ? nonZero : [currencyOf({})];
  return shown.sort().map((c) => formatMoney(sums[c] || 0, c)).join(' · ');
};
